import { ReactNode } from "react";
import { PostHogProvider } from "@posthog/react";
import ENV from "@/utils/env";

/* Types */
interface StudioPostHogProviderProps {
  children: ReactNode;
}

/** StudioPostHogProvider
 *
 * This provider is responsible for initializing the PostHog analytics
 * and making it available throughout the application.
 */
export const StudioPostHogProvider = ({ children }: StudioPostHogProviderProps) => {
  if (!ENV.POSTHOG_TOKEN) {
    return <>{children}</>;
  }

  return (
    <PostHogProvider
      apiKey={ENV.POSTHOG_TOKEN}
      options={{
        api_host: ENV.POSTHOG_HOST,
        capture_pageview: false,
        defaults: "2026-01-30",
      }}
    >
      {children}
    </PostHogProvider>
  );
};
